import _ from 'lodash';
import {Region} from '../../../../serp/classes';

angular.module('cian.filter')
.controller('FilterCtrl', ["$scope", "$rootScope", "$window", "$log", "FilterService", "FilterTermsService", "UserService", "RegionUtilsService", "FilterTagsService", "SerpListService", "AnalyticsService", "MetaService", "ScrollService", "RegionIds", function($scope, $rootScope, $window, $log, FilterService, FilterTermsService, UserService, RegionUtilsService, FilterTagsService, SerpListService, AnalyticsService, MetaService, ScrollService, RegionIds) {
  const ctrl = this;

  ctrl.FilterService = FilterService;

  // Серверная модель фильтров, содержит только типы фильтров и их значения
  const initialQuery = $window.cianConfig.query;

  // Дополнительные данные по фильтрам
  // Например сюда попадает такая информация как название и цвет линии станции метро
  const additionalFiltersData = $window._existingSearchTags;

  FilterService.init(
    initialQuery,
    RegionUtilsService.getInitialRegions(),
    additionalFiltersData
  );

  AnalyticsService.trackPageView({
    fullUrl: SerpListService.getFullUrl(),
    sortType: FilterService.filter.sort.value,
    searchConditions: initialQuery,
  });

  $scope.$watch(function() {
    return FilterService.filter;
  }, function(newValue) {
    $scope.filter = newValue;
  });

  // При изменении модели фильтров, которая отправляется на сервер,
  // делаем запрос на количество результатов по такому фильтру
  $scope.$watch(function () {
    return FilterService.query;
  }, function (newValue, oldValue) {
    // Игнорируем первое срабатывание $watch
    if (newValue !== oldValue) {
      MetaService.updateMeta(newValue);
    }
  });

  $scope.$watch(function() {
    return FilterTagsService.tags;
  }, function(newValue) {
    $scope.tags = newValue;
  });

  angular.extend($scope, {
    isAuthenticated : UserService.isAuthenticated,
    terms           : FilterTermsService
  });

  // Scope methods

  $scope.isMO = FilterService.isMO;

  $scope.isMoscow = function () {
    return RegionUtilsService.isMoscow(FilterService.selectedRegions);
  };

  $scope.isSpbOrLO = function () {
    return RegionUtilsService.isSpbOrLO(FilterService.selectedRegions);
  };

  $scope.isHighwayAvailable = FilterService.isHighwayAvailable;

  ctrl.isControlVisible = filterName =>
    _.includes(FilterService.getCurrentQuickFilters(), filterName);

  $scope.isDistrictAvailable = function() {
    if ($scope.isMoscow() || $scope.isMO()) {
      // Москва, Москва + МО: показываем
      // Только МО: не показываем
      return $scope.isMoscow()
    }

    return RegionUtilsService.selectedRegionHasDistricts(FilterService.selectedRegions);
  };

  $scope.isMetroAvailable = FilterService.isMetroAvailable;

  // $scope.$watchGroup(['common.offerType', 'common.dealType'], function(obj) {
  //   var type = obj.join('');

  //   if ($scope.filter) $scope.filter['_type'] = type;
  // });

  // Новостройка
  $scope.isNewBuilding = FilterService.isNewBuilding;

  $scope.selectedRegionsHasNewBuildings =
    () => RegionUtilsService.areNewBuildingsAvailable(FilterService.selectedRegions);

  $scope.isShortTerm = FilterService.isShortTerm;
  $scope.categoryIs = FilterService.categoryIs;
  $scope.dealTypeIs = FilterService.dealTypeIs;

  ctrl.showOffersClick = function () {
    AnalyticsService.trackCA('Listing', 'show_objects_click', MetaService.lastMeta && MetaService.lastMeta.url, {});
  };

  /** @memberOf filterCtrl */
  ctrl.objectIsSelected = FilterService.objectIsSelected;
  /** @memberOf filterCtrl */
  ctrl.selectedObjectIs = FilterService.selectedObjectIs;
}]);



// WEBPACK FOOTER //
// ./src/components/filter/src/scripts/cian.filter.ctrl.js